import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, change } from 'redux-form';
import { FieldForm } from '@app/src/common/FieldForm';
import { renderSearchJob } from '@app/src/common/SearchJob';
import {
  fetchModelVehicle,
  setModelVehicleSelected,
  clearModelVehicleData,
  clearModelVehicleSelected
} from '@app/src/views/StepOne/form';
import { COLORS } from '@app/src/ui';
import * as validate from '@app/src/utils/validations';
import { ModelVehicleModel } from '@app/src/views/StepOne/form/models/modelVehicle';

const isClient = validate.isClientEnv();
const BREAKPOINT = 768;

interface Props {
  brandVehicle: number;
  typeVehicle: number;
  isDisabled?: boolean;
}

export const InputModelVehicle: React.FC<Props> = ({ brandVehicle, typeVehicle, isDisabled }) => {
  const dispatch = useDispatch();
  const models = useSelector(state => state.modelVehicle.data);
  const isLoading = useSelector(state => state.modelVehicle.isFetching);
  const print = useSelector(state => state.print.general);
  const printModelName = useSelector(state => state.print.general.modelVehicleName);
  const modelSelected = useSelector(state => state.modelVehicle.selected);
  const message = useSelector(state => state.modelVehicle.message);
  const [ inputValue, setInputValue ] = useState('');

  useEffect(() => {
    if (inputValue) {
      dispatch(fetchModelVehicle(typeVehicle, brandVehicle, inputValue));
    }
  }, [inputValue]);

  useEffect(() => {
    if (isClient && window.innerWidth < BREAKPOINT && brandVehicle) {
        dispatch(fetchModelVehicle(typeVehicle, brandVehicle));
    }
    if (print.brandVehicle !== brandVehicle) {
      dispatch(clearModelVehicleSelected());
      dispatch(change('stepOne', 'modelVehicle', null));
      dispatch(change('stepOne', 'modelAdecsys', null));
      dispatch(change('stepOne', 'modelVehicleName', ''));
      setInputValue('');
    }
  }, [brandVehicle, typeVehicle]);

  useEffect(() => {
    if (printModelName) {
      dispatch(change('stepOne', 'modelVehicleName', print.modelVehicleName));
      dispatch(change('stepOne', 'modelVehicle', print.modelVehicle));
      dispatch(change('stepOne', 'modelAdecsys', print.modelAdecsys));
      dispatch(setModelVehicleSelected(printModelName));
    }
  }, [printModelName]);

  const handleChangeSearch = (data: ModelVehicleModel) => {
    if (data) {
      const { name, id, adecsysId } = data;
      dispatch(change('stepOne', 'modelVehicle', id));
      dispatch(change('stepOne', 'modelAdecsys', adecsysId));
      dispatch(change('stepOne', 'modelVehicleName', name));
      dispatch(setModelVehicleSelected(name));
    }
  };

  const handleChangeInput: Function = (value: string) => {
    setInputValue(value);
  };

  const handleClickClose = () => {
    dispatch(clearModelVehicleData());
    dispatch(clearModelVehicleSelected());
    dispatch(change('stepOne', 'modelVehicle', null));
    dispatch(change('stepOne', 'modelAdecsys', null));
    dispatch(change('stepOne', 'modelVehicleName', ''));
    dispatch(change('stepOne', 'yearVehicle', ''));
  };

  const handleClickOpenModal = useCallback(() => {
    if (models && models.length === 0) {
      dispatch(fetchModelVehicle(typeVehicle, brandVehicle));
    }
  }, [typeVehicle, models]);

  const handleBlurSearch = () => {
    if (!modelSelected) {
      dispatch(change('stepOne', 'modeldVehicle', null));
      dispatch(change('stepOne', 'modeldVehicleName', ''));
      dispatch(change('stepOne', 'modeldAdecsys', null));
    }
  };

  return(
  <FieldForm label="Modelo">
    <Field
      name="modelVehicleName"
      component={renderSearchJob}
      dataList={models}
      handleChange={handleChangeSearch}
      handleChangeInput={handleChangeInput}
      handleClickClose={handleClickClose}
      handleClickOpenModal={handleClickOpenModal}
      handleBlur={handleBlurSearch}
      isLoading={isLoading}
      placeholder="Ej. Toyota"
      activeColor={COLORS.AMBAR}
      modalTitle="Seleccionar modelo"
      optionColor={COLORS.AMBAR}
      defaultJob={modelSelected}
      message={message}
      validate={[validate.required]}
      minCharForSearch={1}
      disabled={isDisabled}
    />
  </FieldForm>
)};
